module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select2_g right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.label),
      expression: "value.label"
    }],
    class: {
      on: _vm.open
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.value.label)
    },
    on: {
      "click": _vm.changeOpen,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "label", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.open) ? _c('ul', _vm._l((_vm.options), function(vo) {
    return _c('li', {
      class: {
        on: vo.label == _vm.value.label
      },
      on: {
        "click": function($event) {
          return _vm.changeOption(vo)
        }
      }
    }, [_vm._v(_vm._s(vo.label))])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-493509ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sdSelect.vue
// module id = 860
// module chunks = 1